import React from "react";
import Hero from "../../components/medical/Hero";
import { FAQ_FOR_COMPANIES } from "../../data/faqForCompaniesData";
import FaqSection from "../../components/FaqSection";
import HighlightedContactSection from "../../components/HighlightedContactSection";

export default function FaqPage() {
  return (
    <>
      <Hero title="FAQ" subheading="Antworten auf die wichtigsten Fragen zu unserer Beratung." />
      <section className="bg-white pt-0 pb-16">
        <div className="container-app mx-auto">
          <FaqSection items={FAQ_FOR_COMPANIES} />
        </div>
        <HighlightedContactSection
          heading="Weitere Fragen?"
          description="Ihre Frage war nicht dabei? Wir beantworten sie gerne persönlich."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-faq-contact"
        />
      </section>
    </>
  );
}
